export default {
  setWorkflowCurrentStep(state, val) {
    state.newGI.workflowCurrentStep = val.currentStep
  },

  setPolicyTypeList(state, val) {
    state.newGI.policyTypeList = val.list
  },

  setCurrentStepFieldValue(state, val) {
    state.newGI.fields[val.name] = val.value
  },

  setCurrentStepFieldStatus(state, val) {
    state.newGI.fields[val.name].disabled = val.disabled
    state.newGI.fields[val.name].hide = val.hide
  },

  setGIProductFields(state, val) {
    state.newGI.policyFields = val.fieldList
  },

  setGIPolicyID(state, val) {
    state.newGI.policyID = val.policyID
  },

  setPaymentMethodID(state, val) {
    state.newGI.paymentMethodID = val.paymentMethodID
  },

  setGITypeID(state, val) {
    state.newGI.giTypeID = val.giTypeID
  },



  setGITypeInfo(state, val) {
    state.newGI.giTypeInfo = val.giTypeInfo
  },

  setGIGeneralInfo(state, val) {
    state.newGI.giGeneralInfo = val.giGeneralInfo
    state.newGI.giPaymentMethod = val.giPaymentMethod
  },

  setGIApproveAgent(state, val) {
    state.newGI.giGeneralInfo.approveAgent = val.approveAgent
  },

  setGIAttachments(state, val) {
    state.newGI.giAttachments = val.giAttachments
  },

  setIsRejected(state, val) {
    state.newGI.isRejected = val.value
  },

  setIsCompleted(state, val) {
    console.debug('commited')
    state.newGI.isCompleted = val.value
  },

  setName(state, val) {
    state.newGI[val.key].chinese = val.chinese
    state.newGI[val.key].english = val.english
  },

  setPolicyAgent(state, val) {
    state.newGI.giGeneralInfo.policyAgent = val.policyAgent;
  },
  resetGIPolicyIDs(state) {
    // Reset Policy Agent
    let policyAgent = state.newGI.giGeneralInfo.policyAgent;
    policyAgent.forEach((value, index) => {
      delete value.ID;
      delete value.policyID;
    });

    // ResetIDs
    delete state.newGI.giGeneralInfo.ID;
    delete state.newGI.giPaymentMethod.ID;
    delete state.newGI.giTypeInfo.ID;

  },

  updatePaymentMethodLinkedEntityID(state, val) {
    state.newGI.giPaymentMethod.linkedEntityID = val.linkedEntityID;
    // console.log( state.newGI.giPaymentMethod.linkedEntityID);
  },
  setSelections(state, val) {
    console.debug(val.selections);
    state.selections = val.selections
  },

  disabledButtonStatus(state){
    let obj = state.newGI.fields;
    obj.prevBtn.hide = true;
    obj.nextBtn.hide = true;
    obj.deleteBtn.hide = true;
    obj.inforceBtn.hide = true;
    obj.rejectBtn.hide = true;
    obj.saveBtn.hide = true;
  }

}



// WEBPACK FOOTER //
// ./src/Osm/GIPolicy/store/mutations.js